import { Directive, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { SharedService } from './shared.service';

@Directive({
  selector: '[appHideHeader]'
})
export class HideHeaderDirective{
  constructor(
    private sharedService:SharedService
  ) { }

  

  @HostListener('ionScroll', ['$event']) onContentScroll($event: any) {
    this.sharedService.contentScroll($event);
    
  }

}
